export default "<app-strip [appType]=\"'CF'\" [data]=\"data\"></app-strip>";